import script from "./GlobalLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoading.vue?vue&type=style&index=0&id=380b6153&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380b6153"]])

export default __exports__